import objectReduce from 'fast-loops/lib/objectReduce';

export default function resolveUsedProps(props, src) {
  return objectReduce(src, function (output, value, prop) {
    if (props.indexOf(prop) === -1 && prop !== 'innerRef' && prop !== 'is') {
      output.push(prop);
    }

    return output;
  }, []);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/resolveUsedProps.js
// module id = 1152
// module chunks = 0